module.exports = __webpack_public_path__ + "img/5_license-sp.8c826067.jpg";